export const main = (filters) => [
  { text: '', value: 'actions', width: 100 },

  // {
  //   text: 'Mã cửa hàng',
  //   align: 'start',
  //   value: 'storeCode',
  //   width: '7rem',
  //   filter: value => {
  //     const f = filters.find(x => x.name === 'storeCode')?.value
  //     if (!f) return true
  //     return value?.toLowerCase().includes(f.toLowerCase())
  //   }
  // },
  {
    text: 'Phân loại',
    align: 'start',
    value: 'type',
    width: '10rem',
    filter: value => { 
      return true
    }
  },

  {
    text: 'Tên cửa hàng',
    align: 'start',
    value: 'storeName',
    width: '12rem',
    filter: value => {
      const f = filters.find(x => x.name === 'storeName')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Alias',
    align: 'start',
    value: 'storeAlias',
    width: '8rem',
    filter: value => {
      const f = filters.find(x => x.name === 'storeAlias')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },
  {
    text: 'Địa chỉ',
    align: 'start',
    value: 'address',
    width: '10rem',
    filter: value => { 
      return true
    }
  },

  {
    text: 'Người tạo',
    align: 'start',
    value: 'createdByName',
    width: '10rem',
    filter: value => {
      const f = filters.find(x => x.name === 'createdByName')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Trạng thái',
    align: 'center',
    value: 'status',
    width: '6rem',
    filter: value => {
      const f = filters.find(x => x.name === 'status')?.value
      if (f === undefined || f === null || f === '') return true
      return value === Number(f)
    }
  },

  {
    text: 'Loại',
    align: 'center',
    value: 'type',
    width: '6rem',
    filter: value => {
      const f = filters.find(x => x.name === 'type')?.value
      if (!f) return true
      return value === f
    }
  }
]

export const view = (filters) => [
//   {text: '', value: 'actions', width: 100},
  { text: 'ID', align: 'start', value: 'id', width: '5rem',  
      filter: value => {
                  if ( !filters.find(x=>x.name === 'id')?.value) return true
                  return value == filters.find(x=>x.name === 'id')?.value
      }
  },
  
  { text: 'Nhóm', align: 'start', value: 'conditionGroup', width: '10rem',},
  { text: 'Điều kiện', align: 'start', value: 'conditionTitle' },
  
  { text: 'Đánh giá', align: 'start', value: 'score' }
]

export const detailHeaders= (filters) => [
  // { text: '', value: 'actions', width: 100 },


  {
    text: 'Mã CV',
    value: 'jobTypeCode',
    width: '6rem',
    filter: value => {
      const f = filters.find(x => x.name === 'jobTypeCode')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Loại công việc',
    value: 'jobTypeName',
    width: '8rem',
    filter: value => {
      const f = filters.find(x => x.name === 'jobTypeName')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Mô tả',
    value: 'description',
    width: '14rem',
    filter: value => {
      const f = filters.find(x => x.name === 'description')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Hình ảnh',
    value: 'imageUrl1',
    width: '6rem',
    sortable: false,
    filter: () => true
  },

  {
    text: 'Trạng thái',
    value: 'status',
    width: '6rem',
    align: 'center',
    filter: value => {
      const f = filters.find(x => x.name === 'status')?.value
      if (f === '' || f === null || f === undefined) return true
      return value === Number(f)
    }
  },

  {
    text: 'Cập nhật bởi',
    value: 'updatedByName',
    width: '9rem',
    filter: value => {
      const f = filters.find(x => x.name === 'updatedByName')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Ngày cập nhật',
    value: 'updatedAt',
    width: '9rem',
    filter: () => true
  }
]

export const readyHeaders = [
  { text: 'Mã nhân viên', align: 'start', value: 'employeeCode' },
  { text: 'Tên nhân viên', align: 'start', value: 'employeeName' },
  { text: 'Ngày nhận việc', align: 'start', value: 'hireDate' },
  { text: 'Phân loại', align: 'start', value: 'type' },
  { text: 'Mã NS đánh giá', align: 'start', value: 'finalManagerCode' },
  { text: 'Người đánh giá', align: 'start', value: 'finalManagerName' },
  { text: 'Chỉ định người đ/giá (tạm thời)', align: 'start', value: 'smCode' },
]